export default __webpack_public_path__ + "static/media/med.7b57aaf1.png";